"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);

// src/use-combined-refs.ts
var import_react = require("react");
var useCombinedRefs = (...refs) => {
  const targetRef = (0, import_react.useRef)(null);
  (0, import_react.useEffect)(() => {
    refs.forEach((ref) => {
      if (!ref)
        return;
      if (typeof ref === "function") {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
};

// src/index.tsx
var import_react2 = __toESM(require("react"));
var import_prop_types = __toESM(require("prop-types"));
var import_playback_core = require("@mux/playback-core");

// src/env.ts
var getEnvPlayerVersion = () => {
  try {
    return "0.0.1-beta.1";
  } catch {
  }
  return "UNKNOWN";
};
var player_version = getEnvPlayerVersion();
var getPlayerVersion = () => player_version;

// src/index.tsx
var playerSoftwareVersion = getPlayerVersion();
var playerSoftwareName = "ix-video-react";
var IxVideo = import_react2.default.forwardRef((props, ref) => {
  var _a;
  const { playbackId, src: outerSrc, children, autoPlay, preload, ...restProps } = props;
  const [playerInitTime] = (0, import_react2.useState)((0, import_playback_core.generatePlayerInitTime)());
  const [src, setSrc] = (0, import_react2.useState)((_a = (0, import_playback_core.toMuxVideoURL)(playbackId)) != null ? _a : outerSrc);
  const playbackCoreRef = (0, import_react2.useRef)(void 0);
  const innerMediaElRef = (0, import_react2.useRef)(null);
  const mediaElRef = useCombinedRefs(innerMediaElRef, ref);
  (0, import_react2.useEffect)(() => {
    var _a2;
    setSrc((_a2 = (0, import_playback_core.toMuxVideoURL)(playbackId)) != null ? _a2 : outerSrc);
  }, [outerSrc, playbackId]);
  (0, import_react2.useEffect)(() => {
    const propsWithState = {
      ...props,
      src,
      playerInitTime,
      playerSoftwareName,
      playerSoftwareVersion,
      autoplay: autoPlay
    };
    let mediaEl = mediaElRef.current;
    if (mediaEl) {
      playbackCoreRef.current = (0, import_playback_core.initialize)(propsWithState, mediaEl, playbackCoreRef.current);
    }
    return () => {
      (0, import_playback_core.teardown)(mediaEl, playbackCoreRef.current);
      mediaEl = void 0;
      playbackCoreRef.current = void 0;
    };
  }, [src]);
  (0, import_react2.useEffect)(() => {
    var _a2;
    (_a2 = playbackCoreRef.current) == null ? void 0 : _a2.setAutoplay(autoPlay);
  }, [autoPlay]);
  (0, import_react2.useEffect)(() => {
    var _a2;
    (_a2 = playbackCoreRef.current) == null ? void 0 : _a2.setPreload(preload);
  }, [preload]);
  return /* @__PURE__ */ import_react2.default.createElement("video", { ref: mediaElRef, ...restProps }, children);
});
IxVideo.propTypes = {
  envKey: import_prop_types.default.string,
  debug: import_prop_types.default.bool,
  disableCookies: import_prop_types.default.bool,
  metadata: import_prop_types.default.any,
  beaconCollectionDomain: import_prop_types.default.string,
  playbackId: import_prop_types.default.string,
  playerInitTime: import_prop_types.default.number,
  preferPlayback: import_prop_types.default.oneOf(Object.values(import_playback_core.PlaybackTypes)),
  type: import_prop_types.default.oneOf(import_playback_core.allMediaTypes),
  streamType: import_prop_types.default.oneOf(Object.values(import_playback_core.StreamTypes)),
  startTime: import_prop_types.default.number
};
var src_default = IxVideo;
//# sourceMappingURL=index.cjs.js.map
